import { render, staticRenderFns } from "./exhibition-contact-exhibition.vue?vue&type=template&id=d2b3c520&scoped=true&"
import script from "./exhibition-contact-exhibition.vue?vue&type=script&lang=js&"
export * from "./exhibition-contact-exhibition.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-contact-exhibition.vue?vue&type=style&index=0&id=d2b3c520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b3c520",
  null
  
)

export default component.exports